module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"gl":{"download-txt":"Descargar como ficheiro de texto","download-pdf":"Descargar como PDF","download-txt-name":"centros.txt","download-pdf-name":"centros.pdf","title":"Exportar Centros","copy-clipboard":"Copiar ó portapapeis","explicacion-1":"No seguinte cadro podes ver os códigos de todos os centros que tiñas na lista por orde:"},"es":{"download-txt":"Descargar como ficheiro de texto","download-pdf":"Descargar como PDF","download-txt-name":"centros.txt","download-pdf-name":"centros.pdf","title":"Exportar Centros","copy-clipboard":"Copiar al portapapeles","explicacion-1":"En el siguiente cuadro puedes ver los códigos de todos los centros que tenías en la lista por orden:"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/ModalExportCenters.vue
// module id = 90
// module chunks = 0